export class UpdProUserSharingPutReq {
    userID?: string | null;
    permission?: string | null;
}